/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Injectable, ApplicationRef } from '@angular/core';
import { IceNavService } from '../../../../projects/icemedx-lib/src/components/ice-nav/ice-nav.service';
import { DomainService } from 'projects/icemedx-lib/src/services/domain/domain.service';
import { IcecontrolPermission } from '../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../icemedx-lib/src/login/login.config';
import { IceTypes } from '../../../icemedx-lib/src/models/icetypes';
import { Iceutility } from '../../../icemedx-lib/src/services/iceutility';
import { LoginService } from '../../../icemedx-lib/src/login/login.service';
import { DomainAppService } from '../../../icemedx-lib/src/services/baseapp.service';

@Injectable()
export class AppService extends DomainAppService {
  constructor(navSvc: IceNavService, domainSvc: DomainService, loginSvc: LoginService, app: ApplicationRef) {
    super(navSvc, domainSvc, loginSvc, app);

    this.setCustomBrandName('NetworkNow Pharmacy Portal');
  }

  public defaultMenus() {
    super.defaultMenus();
    this.pharmacydomainMenus();

    if (Iceutility.isMobileDevice()) {
      let pharmBar = this.addBreadcrumbToolbar("PharmacyToolbar");
      if (pharmBar != null) {
        let menuItems: any[] = [
          { display: "Open", permission: new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaReadOnly), active: true, id: "root", link: "" },
        ];

        let sideItems = this.getNavService().getSideMenuItems();
        for (let i = 0; i < sideItems.length; i++) {
          let smItm = sideItems[i];
          if (smItm == null) continue;

          let classes = smItm.iconClassToAdd.split(' ');
          let classesToAdd = {};
          for (let j = 0; j < classes.length; j++) {
            classesToAdd[classes[j]] = true;
          }

          classesToAdd["fa-3x"] = true;

          pharmBar.items.push({
            display: smItm.text,
            menuitem: "appMenu1",
            data: smItm,
            domain: "",
            domaintype: IceTypes.ACCOUNT_TYPE.actNone,
            link: smItm.routeUrl,
            properties: {
              class: classesToAdd,
              color: 'black'
            }
          });
        }
        pharmBar["appMenu1"] = { menuItems: menuItems };
      }
    }
  }
}
